import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { Routes } from '@angular/router';
import { createDynamicRouteResolver } from '../../dynamic-routes';
import { privateGuard } from './guards/private.guard';
import { ItemViewScreenComponent } from './item-views/screens/item-view-screen/item-view-screen.component';
import { PrivateComponent } from './private.component';

const privateDynamicRouteResolver = createDynamicRouteResolver('private');

export default [
  {
    path: '',
    component: PrivateComponent,
    canActivate: [AngularFireAuthGuard, privateGuard],
    data: {
      breadcrumb: 'Private',
      excludeFromBreadcrumb: true,
      authGuardPipe: () => redirectUnauthorizedTo(['identity']),
    },
    children: [
      {
        path: 'login-referrer',
        pathMatch: 'full',
        redirectTo: '',
      },
      {
        path: 'my-account',
        data: {
          breadcrumb: 'My Account',
        },
        loadChildren: () =>
          import('./manage-identity/manage-identity.module').then(
            (module) => module.ManageIdentityModule,
          ),
      },
      {
        path: 'my-organisations',
        pathMatch: 'full',
        loadChildren: () =>
          import('./manage-organisations/manage-organisations.module').then(
            (module) => module.ManageOrganisationsModule,
          ),
      },
      {
        path: 'private/invitation-list',
        pathMatch: 'full',
        redirectTo: 'my-account/organisations',
      },
      {
        path: 'item',
        children: [
          {
            path: ':alias',
            data: { breadcrumbDynamic: 'definition-name' },
            children: [
              {
                path: ':itemId',
                pathMatch: 'full',
                data: { breadcrumbDynamic: 'item-name' },
                component: ItemViewScreenComponent,
              },
              {
                path: 'items',
                pathMatch: 'full',
                loadChildren: () =>
                  import('./item-views/item-views.module').then((module) => module.ItemViewsModule),
              },
              {
                path: '',
                pathMatch: 'full',
                loadComponent: () =>
                  import('./dynamic-private-route.component').then((m) => m.DynamicPrivateRoute),
                resolve: { dynamicRoute: privateDynamicRouteResolver },
                data: { breadcrumbDynamic: 'dashboard' },
              },
            ],
          },
        ],
      },
      {
        path: 'chat',
        data: { breadcrumb: 'Chat' },
        loadChildren: () => import('./chat/chat.routes').then((m) => m.default),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./dynamic-private-route.component').then((m) => m.DynamicPrivateRoute),
        resolve: { dynamicRoute: privateDynamicRouteResolver },
        data: { breadcrumbDynamic: 'dashboard' },
      },
    ],
  },
] satisfies Routes;
